import { handleLoginClick2, loginInFreemium } from "@utils/common";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import firebase from "@utils/constants/firebase";
import { MINI_SUBSCRIPTION, TOAST_ID } from "@utils/constants";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { closePopup, openPopup } from "@common/Modal/action";
import { withRouter } from "react-router";
import { openLoginPopup } from '@containers/Login/APIs/actions';
import get from "lodash/get";
import {
    showLoginScreen
} from "@utils/common";

const removeLoginNotNowToast = () => {
    
    const loginNotNowToast = document.getElementById(TOAST_ID.LOGIN_NOT_NOW_TOAST);
    const logingsToastContainter = document.querySelector('.Toastify__toast-container');
    if (loginNotNowToast) {
        toast.dismiss()
        loginNotNowToast.style.setProperty('display', 'none', 'important');
        logingsToastContainter.style.setProperty('display', 'none', 'important');
    }
}

const LoginNotNow = ({openPopup, closePopup, openLoginPopup ,showNotNowPopup,history}) => {
    
    // window.location.reload();
    handleLoginClick2();
    useEffect(()=>{
        // const logingsToastContainter = document.querySelector('.Toastify__toast-container');
        window.addEventListener('blur',removeLoginNotNowToast);
        let queryParams = new URLSearchParams(location.search)
        queryParams.has("status") && ( history.replace({pathname: location.pathname,search: '' }) )
        // logingsToastContainter.style.setProperty('display', 'none', 'important');
        return () => window.removeEventListener('blur', removeLoginNotNowToast);
    },[])

    let getSource = firebase.VALUE.PLAYBACK;
    return <div className="login-not-now">
        <i className="icon-alert-upd" />
        <div className="text-fail">
            <div>Login not successful.&nbsp;</div>
            {/* <div onClick={async () => await loginInFreemium({ openPopup, closePopup, openLoginPopup, source: firebase.VALUE.HOME, getSource, ComponentName: MINI_SUBSCRIPTION.LOGIN, fromLogin: showNotNowPopup })}>Please Try Again */}
            <div onClick={async () => window.location.reload(true)}>Please Try Again
            </div>
        </div>
    </div>
};

LoginNotNow.propTypes = {
    showNotNowPopup: PropTypes.object,
    openPopup: PropTypes.func,
    closePopup: PropTypes.func,
    openLoginPopup: PropTypes.func,
};
function mapStateToProps(state) {
    return {
        miniSubscription: get(state.subscriptionDetails, "miniSubscription"),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(
            {

                openPopup,
                closePopup,
                openLoginPopup
            },
            dispatch,
        ),
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginNotNow));

